/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable no-unused-vars */
import React from "react";
import "./InterviewSubmitReview.scss";
import useInterviewSubmitReview from "./useInterviewSubmitReview";
import { Spinner } from "react-bootstrap";
import MainLayout from "../../Common/MainLayout";

export default (props) => {
  const { loading, jobsLinkedWithAssignedKit, onSubmitClick } =
    useInterviewSubmitReview();

  return (
    <MainLayout pageName={"Interview Submit"}>
      <div className="interview-success-wrapper">
        {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <div className="container mt-3">
            <h1 className="text-center mb-5">
              You’ve completed your Assessment session
            </h1>

            {Array.isArray(jobsLinkedWithAssignedKit) &&
            jobsLinkedWithAssignedKit.length > 0 ? (
              <>
                {Array.isArray(jobsLinkedWithAssignedKit) &&
                  jobsLinkedWithAssignedKit.map((item) => (
                    <div
                      className="border mt-4 rounded-lg mb-3 p-3 interview-inner mx-auto"
                      key={item?.id}
                    >
                      <div className="content">
                        <h2 className="font-weight-medium  mb-2">
                          Submit your assessment for the post of{" "}
                          <strong className="text-capitalize pt-5">
                            {item?.job_details && item.job_details?.title}
                          </strong>
                        </h2>
                        <p className="mb-2">
                          Posted by:{" "}
                          {/* {dateDiffInDays(new Date(item?.interview_before))} days, */}
                          {item?.job_details &&
                            item.job_details?.posted_by_details &&
                            item.job_details.posted_by_details
                              ?.company_details &&
                            item.job_details.posted_by_details.company_details
                              ?.name}
                          <span>
                            {item?.job_details &&
                              item.job_details?.posted_by_details &&
                              item.job_details.posted_by_details
                                ?.company_details &&
                              item.job_details.posted_by_details.company_details
                                ?.state_name}
                          </span>
                        </p>

                        <div className="d-flex mb-2 align-items-center">
                          <p className="mb-0 text-nowrap">Skills Required: </p>
                          {Array.isArray(
                            item.job_details && item.job_details.skill_names
                          ) &&
                          item.job_details &&
                          item.job_details.skill_names.length ? (
                            <>
                              <ul className="d-flex align-items-center flex-wrap ml-2">
                                {Array.isArray(
                                  item.job_details &&
                                    item.job_details.skill_names
                                ) &&
                                  item.job_details &&
                                  item.job_details.skill_names.map((item) => (
                                    <>
                                      <li className="mr-2 bg-grey fs-smallest px-2 my-1 py-1 rounded">
                                        {item}
                                      </li>
                                    </>
                                  ))}
                              </ul>
                            </>
                          ) : null}
                        </div>
                      </div>

                      <div className="action d-flex justify-content-between align-items-center">
                        <p className="mb-0">Applied: {item?.applied_date}</p>
                        {item?.is_submit == true ? (
                          <h4 className="bg-grey p-1 rounded-lg"> Status: Already Submitted</h4>
                        ) : (
                          <button
                            className="btn btn-primary"
                            onClick={() =>
                              onSubmitClick(
                                item?.job_details && item.job_details?.id
                              )
                            }
                          >
                            Submit Assessment
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
              </>
            ) : (
              <h3 className="text-center text-danger">Unable to find the jobs linked with this assessment kit.</h3>
            )}
          </div>
        )}
      </div>
    </MainLayout>
  );
};
